import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { Observable, ReplaySubject } from 'rxjs';

import {
  ConfigureBrandPaymentChannelsParams,
  ConfigureBrandPaymentChannelsResponse,
  GetBrandPaymentChannelsParams,
  GetBrandPaymentChannelsResponse,
  ListPaymentChannelsResponse,
  PaymentChannel,
} from '../../payment-channel';

import { ApiService } from 'src/app/core/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentChannelService {
  private paymentChannelsSubject = new ReplaySubject<PaymentChannel[]>(1);
  public paymentChannels = this.paymentChannelsSubject.asObservable();

  constructor(private readonly apiService: ApiService) {}

  listPaymentChannels(): Observable<ListPaymentChannelsResponse> {
    return this.apiService.get(`/v1/payment-channels/list`);
  }

  fetchBrandPaymentChannels(
    getBrandPaymentChannelsParams: GetBrandPaymentChannelsParams
  ) {
    let params: HttpParams = this.apiService.queryParams(
      getBrandPaymentChannelsParams
    );

    this.apiService
      .get(
        `/v1/brands/${getBrandPaymentChannelsParams.brandUuid}/payment-channels`,
        params
      )
      .subscribe((res: GetBrandPaymentChannelsResponse) =>
        this.paymentChannelsSubject.next(res.paymentChannels || [])
      );
  }

  getBrandPaymentChannels(
    getBrandPaymentChannelsParams: GetBrandPaymentChannelsParams
  ): Observable<GetBrandPaymentChannelsResponse> {
    const params: HttpParams = this.apiService.queryParams(
      getBrandPaymentChannelsParams
    );
    return this.apiService.get(
      `/v1/brands/${getBrandPaymentChannelsParams.brandUuid}/payment-channels`,
      params
    );
  }

  configureBrandPaymentChannels(
    configureBrandPaymentChannelsParams: ConfigureBrandPaymentChannelsParams
  ): Observable<ConfigureBrandPaymentChannelsResponse> {
    return this.apiService.post(
      `/v1/brands/${configureBrandPaymentChannelsParams.brandUuid}/payment-channels`,
      configureBrandPaymentChannelsParams
    );
  }
}
